import React, { FC, MouseEventHandler } from 'react'
import { Button as MUIButton } from '@mui/material'
import { type ButtonProps as MUIButtonProps } from '@mui/material/Button'

type OnClickAsyncFunction = () => Promise<void>

export interface ButtonPropsOverride {
  onClick?: OnClickAsyncFunction | MouseEventHandler<HTMLButtonElement>
}

export type ButtonProps = ButtonPropsOverride & Omit<MUIButtonProps, 'onClick'>

const Button: FC<ButtonProps> = (props) => {
  return <MUIButton {...props} />
}

export default Button
